import React from "react";
import styled from "styled-components";
import { useNavigate, useNavigationType } from "react-router-dom";

const TitleBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    margin: 20px 0;
`;

const PokemonName = styled.span`
    font-size: 36px;
    font-weight: normal;

    @media all and (max-width:479px) {
        font-size: 1.5rem;
    }
`;

const PokemonNumber = styled.span`
    font-size: 20px;
    font-weight: normal;

    @media all and (max-width:479px) {
        font-size: 0.75rem;
    }
`;

const StyledButton = styled.button`
    width: 50px;
    height: 50px;
    background-image: url("${process.env.PUBLIC_URL}/media/back.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    background-color: transparent;

    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);

    @media all and (max-width:479px) {
       width: 10vw;
       height: 10vw;
    }
`;

function DetailTitleBox({ pokemonData }) {
    const navigate = useNavigate();
    const navType = useNavigationType();

    const handleBack = () => {
        if (navType === "PUSH") {
            navigate(-1); 
        } else {
            navigate("/"); 
        }
    };
    
    return (
        <TitleBox>
            <StyledButton onClick={handleBack}/>
            <PokemonName>{pokemonData.name}</PokemonName>
            <PokemonNumber>NO.{pokemonData.id}</PokemonNumber>
        </TitleBox>
    );
}

export default DetailTitleBox;
